import { render, staticRenderFns } from "./provoff.vue?vue&type=template&id=d2f02344&"
import script from "./provoff.vue?vue&type=script&lang=js&"
export * from "./provoff.vue?vue&type=script&lang=js&"
import style0 from "./provoff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports